import React from "react";
import {MdOutlineMailOutline} from 'react-icons/md'
import logo from "../logo-asset/tasty-drk.png";
const Updates = () => {
  return (
    <div className="home-cnt">
      <div className="about-cnt">
        <h2 style={{ color: "#fff" }} className="about-title">
          Coming soon:
        </h2>
        <br />
        <span>
          Currently TASTY is in beta version, but I am working on some new
          features including:
        </span>
        <br />
        <br />
        <ul>
          <li>Create an account ( autentication feature )</li>
          <li>Add recipes to favourite</li>
          <li>Marking used ingredients ( text strike through )</li>
          <li>Categories ( holiday recipes, desserts etc.. )</li>
        </ul>
        <br />
        <p>Is there a feature you would like to see ?</p> 
         <a className="email" href="mailto:germano.niko01@gmail.com" > <MdOutlineMailOutline/> shoot me an email</a> <br/><br/>
        <img src={logo} alt="" />
      </div>
    </div>
  );
};

export default Updates;
